import { inject, Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { HttpClient } from '@angular/common/http';
import { AnalyticsService } from 'src/app/core/services/analytics/analytics.service';
import { EventName } from 'src/app/core/services/analytics/event-names';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private http = inject(HttpClient);
  private analytics = inject(AnalyticsService);

  getTranslation(lang: string) {
    this.analytics.log(EventName.FetchTranslation);
    // Append a cache-busting query parameter with each build
    return this.http.get<Translation>(`/assets/i18n/${lang}.json?b=${environment.build}`);
  }
}
